// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar--1I1KD"};